<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'full',
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// Blank.vue?6a0c4b8e